//
//
//
//
//
//
//

import ManualCustomerService from '@/components/ManualCustomerService'
import { KMYK_SERVICE_URL } from '@/utils/constant'

export default {
  name: 'Layout',
  components: {
    ManualCustomerService
  },
  data() {
    return {
      orgUid: '',
      showService: false,
      serviceUrl: ''
    }
  },
  mounted: function () {
    this.orgUid = this.$route.params.orgUid;
    // 康明眼科医院 - 定制人工客服
    if (this.orgUid === 'kmyk') {
      this.showService = true
      this.serviceUrl = KMYK_SERVICE_URL
    }
  }
}



// WEBPACK FOOTER //
// ./src/layout/index.vue